const HowToReachUs = () => {
  const contactMethods = [
    {
      id: 1,
      icon: '/assets/getInTouch/phone.svg',
      title: 'Call Us',
      primary: '+91 9117590663',
      secondary: 'Mon-Sat, 9AM - 6PM IST',
      action: 'tel:+919117590663'
    },
    {
      id: 2,
      icon: '/assets/getInTouch/email.svg',
      title: 'Email Us',
      primary: 'info@avexasystems.com',
      secondary: 'Respond within 24hrs',
      action: 'mailto:info@avexasystems.com'
    },
    // {
    //   id: 3,
    //   icon: '/assets/getInTouch/videocall.svg',
    //   title: 'Video Call',
    //   primary: 'AveraOnSkype',
    //   secondary: 'Schedule video meetings'
    // },
    {
      id: 4,
      icon: '/assets/getInTouch/location.svg',
      title: 'Visit Us',
      primary: 'Hyderabad HQ',
      secondary: 'By appointment only',
      action: 'scroll'
    }
  ];

  const handleCardClick = (method) => {
  if (method.action === 'scroll') {
    const locationSection = document.getElementById('location-section');
    locationSection?.scrollIntoView({ behavior: 'smooth' });
  } else if (method.action) {
    window.location.href = method.action;
  }
};

  return (
    <section className="bluebg py-12 md:py-20 lg:py-20 ">
      <div className="container mx-auto px-4 md:px-8 max-w-6xl">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14 lg:mb-16">
          <h2 className="font-bold mb-3 md:mb-4">
            How to <span className="">Reach Us</span>
          </h2>
          <p className=" opacity-90 max-w-3xl mx-auto px-4 leading-relaxed">
            Discover how AiDA transforms complex, unstructured data into clear, actionable insights 
            through automation and intelligence.
          </p>
        </div>

        {/* Contact Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-6 lg:gap-8 max-w-3xl mx-auto">
          {contactMethods.map((method, index) => (
            // <div
            //   key={method.id}
            //   className="card-animate group bg-white rounded-2xl p-3 md:p-4 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            //   style={{ 
            //     animationDelay: `${2 + index * 0.8}s`,
            //     animationDuration: '4s'
            //   }}
            // >
            <div
  key={method.id}
  onClick={() => handleCardClick(method)}
  role="button"
  tabIndex={0}
  className="card-animate group bg-white rounded-2xl p-3 md:p-4 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
  style={{ 
    animationDelay: `${2 + index * 0.8}s`,
    animationDuration: '4s'
  }}
>

              {/* Icon */}
              <div className="flex justify-center mb-5 md:mb-6">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-orange-50 group-hover:bg-orange-100 transition-colors duration-300">
                  <img 
                    src={method.icon} 
                    alt={method.title}
                    className="w-6 h-6 md:w-7 md:h-7 object-contain transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="text-center">
                <h3 className="  font-bold mb-1.5">
                  {method.title}
                </h3>
                <p className="light-blue-text  font-medium mb-0.5">
                  {method.primary}
                  <a href="tel:+91 9117590663"></a>
                </p>
                <p className="text-gray-500 ">
                  {method.secondary}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .card-animate {
          animation: sequentialPop ease-in-out infinite;
        }

        @keyframes sequentialPop {
          0%, 90%, 100% {
            transform: scale(1);
          }
          5% {
            transform: scale(1.1);
          }
          10% {
            transform: scale(1);
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .card-animate {
            animation: none;
          }
        }
      `}</style>
    </section>
  );
};

export default HowToReachUs;